// const test_status_column_properties = {
//   type: "singleSelect",
//   valueOptions: [
//     { value: "C", label: "Completed" },
//     { value: "U", label: "Under Test" },
//     { value: "S", label: "OOS" },
//     { value: "T", label: "OOT" },
//     { value: "D", label: "Deviation" },
//     { value: "L", label: "Lab Incident" },
//   ],
// };
// import MachineDropdown from "../../Output/components/MachineDropdown";
// import AnalystDropdown from "../../Output/components/AnalystDropdown";
// import TimeDatePicker from "../../Output/components/TimeDatePicker";
import { Render_output_remarks_cell } from "../../Output/utils/schedule_datagrid_cell_renderer";
import RealTimeAnalystDropdown from "./RealTimeAnalystDropDown";
import RealTimeMachineDropDown from "./RealTimeMachineDropDown";
import RealTimeDatePicker from "./RealTimeDatePicker";

export const get_schedule_table_headers = (aria_label) => {
  // console.log(aria_label);

  return {
    _id: {
      field: "_id",
      headerName: "ID",
      visible: false,
      width: 100,
      hide: true,
    },
    product_code: {
      field: "product_code",
      headerName: "Product Code",
      visible: true,
      editable: false,
      width: 100,
      headerClassName: "bg-[#a7c4dc]",
    },
    product_name: {
      field: "material_name",
      headerName: "Product Name",
      visible: true,
      editable: false,
      width: 110,
      headerClassName: "bg-[#a7c4dc]",
    },
    test_id: {
      field: "test_name",
      headerName: "TEST NAME",
      visible: true,
      editable: false,
      width: 180,
      headerClassName: "bg-[#a7c4dc]",
    },
    spec_id: {
      field: "spec_id",
      headerName: "SPEC ID",
      visible: true,
      editable: false,
      width: 90,
      headerClassName: "bg-[#a7c4dc]",
      // type: "singleSelect",
      // valueOptions: [
      //   { label: "FS015148", value: "FS015148" },
      //   { label: "FS007772", value: "FS007772" },
      //   { label: "FS007940", value: "FS007940" },
      //   { label: "FS011879", value: "FS011879" },
      //   { label: "FS012696", value: "FS012696" },
      //   { label: "FS017600", value: "FS017600" },
      //   { label: "FS015148", value: "FS015148" },
      //   { label: "FS007940", value: "FS007940" },
      //   { label: "FS007772", value: "FS007772" },
      //   { label: "FS011879", value: "FS011879" },
      //   { label: "FS012696", value: "FS012696" },
      //   { label: "FS017600", value: "FS017600" },
      // ],
    },
    qc_receive_date: {
      field: "qc_receive_date",
      headerName: "QC RECEIVE DATE",
      visible: true,
      editable: false,
      width: 160,
      headerClassName: "bg-[#a7c4dc]",
      // type: "date",
    },
    market: {
      field: "market",
      headerName: "MARKET",
      visible: true,
      editable: false,
      width: 150,
      headerClassName: "bg-[#a7c4dc]",
    },
    material_type: {
      field: "sample_type",
      headerName: "MATERIAL TYPE",
      visible: true,
      editable: false,
      width: 150,
      headerClassName: "bg-[#a7c4dc]",
      // type: "singleSelect",
      // valueOptions: [
      //   { label: "SFG(with micro)", value: "SFG(with micro)" },
      //   { label: "SFG(without micro)", value: "SFG(without micro)" },
      //   { label: "FP(with micro)", value: "FP(without micro)" },
      //   { label: 'CB(urgent)', value: 'CB(urgent)' },
      //   { label: 'CB', value: 'CB' },
      //   { label: 'CB(additional)', value: 'CB(additional)' }
      // ],
    },
    pre_start_time: {
      field: "pre_start_time",
      headerName: "ANALYST START TIME",
      visible: true,
      width: 210,
      type: "dateTime",
      editable: false,
      valueGetter: ({ value }) => {
        if (typeof value === "object") return value;
        return new Date(value) || new Date();
      },
      renderCell:
        aria_label === "ongoing_table" || aria_label === "adhoc_table"
          ? null
          : (props) => <RealTimeDatePicker {...props} isEditable={true} />,
      headerClassName: "bg-[#a7c4dc]",
    },
    pre_end_time: {
      field: "pre_end_time",
      headerName: "ANALYST END TIME",
      visible: true,
      width: 210,
      type: "dateTime",
      editable: false,
      valueGetter: ({ value }) => {
        if (typeof value === "object") return value;
        return new Date(value) || new Date();
      },
      renderCell:
        aria_label === "ongoing_table" || aria_label === "adhoc_table"
          ? null
          : (props) => <RealTimeDatePicker {...props} isEditable={true} />,
      headerClassName: "bg-[#a7c4dc]",
    },
    machine_start_time: {
      field: "machine_start_time",
      headerName: "MACHINE START TIME",
      visible: true,
      width: 230,
      headerClassName: "bg-[#a7c4dc]",
      type: "dateTime",
      valueGetter: ({ value }) => {
        if (typeof value === "object") return value;
        return new Date(value) || new Date();
      },
      editable: false,
      renderCell:
        aria_label === "ongoing_table" || aria_label === "adhoc_table"
          ? null
          : (props) => <RealTimeDatePicker {...props} isEditable={true} />,
    },

    machine_end_time: {
      field: "machine_end_time",
      headerName: "MACHINE END TIME",
      visible: true,
      width: 230,
      headerClassName: "bg-[#a7c4dc]",
      type: "dateTime",
      valueGetter: ({ value }) => {
        if (typeof value === "object") return value;
        return new Date(value) || new Date();
      },
      editable: false,
      renderCell:
        aria_label === "ongoing_table" || aria_label === "adhoc_table"
          ? null
          : (props) => <RealTimeDatePicker {...props} isEditable={true} />,
    },
    batch_id: {
      field: "batch_no",
      headerName: "BATCH ID",
      visible: true,
      editable: false,
      width: 90,
      headerClassName: "bg-[#a7c4dc]",
    },

    stp_id: {
      field: "stp_id",
      headerName: "STP ID",
      visible: true,
      editable: false,
      width: 90,
      headerClassName: "bg-[#a7c4dc]",
      // type: "singleSelect",
      // valueOptions: [
      //   { label: "FT007296", value: "FT007296" },
      //   { label: "FT003572", value: "FT003572" },
      //   { label: "FT003702", value: "FT003702" },
      //   { label: "FT005640", value: "FT005640" },
      //   { label: "FT010562", value: "FT010562" },
      //   { label: "FT006061", value: "FT006061" },
      //   { label: "FT008844", value: "FT008844" },
      //   { label: "FT010888", value: "FT010888" },
      // ],
    },

    // step_name: {
    //   field: "step_name",
    //   headerName: "STEP NAME",
    //   visible: true,
    //   editable: false,
    //   width: 210,
    //   headerClassName: "bg-[#a7c4dc]",
    // },
    analyst_id: {
      field: "analyst_id",
      headerName: "ANALYST ID",
      visible: true,
      editable: false,
      width: 200,
      type: "singleSelect",
      headerClassName: "bg-[#a7c4dc]",
      renderCell:
        aria_label === "ongoing_table" || aria_label === "adhoc_table"
          ? null
          : (props) => <RealTimeAnalystDropdown {...props} isEditable={true} />,
      // renderCell: (props) => (
      //
      // ),
    },
    machine_id: {
      field: "machine_id",
      headerName: "MACHINE ID",
      visible: true,
      editable: false,
      width: 200,
      headerClassName: "bg-[#a7c4dc]",
      type: "singleSelect",
      renderCell:
        aria_label === "ongoing_table" || aria_label === "adhoc_table"
          ? null
          : (props) => <RealTimeMachineDropDown {...props} isEditable={true} />,
      // valueOptions: [...machine_list],
    },

    // remark: {
    //   field: "remark",
    //   headerName: "Remark",
    //   visible: true,
    //   editable: false,
    //   width: 180,
    //   headerClassName: "bg-[#a7c4dc]",
    // },
    status: {
      field: "status",
      headerName: "STATUS",
      visible: true,
      editable: true,
      width: 150,
      headerClassName: "bg-[#a7c4dc]",
      type: "singleSelect",
      valueOptions: [
        { value: "Completed", label: "Completed" },
        { value: "Under Test", label: "Under Test" },
        { value: "OOS", label: "OOS" },
        { value: "OOT", label: "OOT" },
        { value: "Deviation", label: "Deviation" },
        { value: "Lab Incident", label: "Lab Incident" },
      ],
      renderCell: (props) => (
        // eslint-disable-next-line react/jsx-pascal-case
        <Render_output_remarks_cell {...props} aria_label={aria_label} />
      ),
    },
    remark: {
      field: "remark",
      headerClassName: "bg-[#a7c4dc]",
      headerName: "REMARKS",
      visible: true,
      editable: false,
      width: 200,
      // ...remark_status_column_properties,
    },
  };
};
